var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldTextActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2998 6.00078C6.2998 5.61418 6.61321 5.30078 6.9998 5.30078H12.9373C13.8713 5.30078 14.7655 5.67577 15.4236 6.34084C16.0815 7.00566 16.4498 7.90581 16.4498 8.84289C16.4498 9.77037 16.089 10.6617 15.4437 11.3245C15.864 11.5151 16.2505 11.7825 16.5821 12.1175C17.2986 12.8416 17.6998 13.8221 17.6998 14.8429C17.6998 15.8637 17.2986 16.8442 16.5821 17.5682C15.8653 18.2925 14.8916 18.7008 13.8748 18.7008H6.9998C6.61321 18.7008 6.2998 18.3874 6.2998 18.0008V6.00078ZM7.6998 12.385V17.3008H13.8748C14.5156 17.3008 15.1316 17.0436 15.587 16.5835C16.0426 16.1231 16.2998 15.4971 16.2998 14.8429C16.2998 14.1887 16.0426 13.5627 15.587 13.1023C15.1316 12.6421 14.5156 12.385 13.8748 12.385H7.6998ZM12.9373 10.985H7.6998V6.70078H12.9373C13.4952 6.70078 14.0317 6.92467 14.4285 7.32559C14.8255 7.72676 15.0498 8.27241 15.0498 8.84289C15.0498 9.41336 14.8255 9.95901 14.4285 10.3602C14.0317 10.7611 13.4952 10.985 12.9373 10.985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldTextActive);
export default __webpack_public_path__ + "static/media/bold-text-active.472e92cfd426a5c000330615efe79afb.svg";
export { ForwardRef as ReactComponent };